const Permissions = {
  GRANTED: 'granted',
  DENIED: 'denied',
  PROMPT: 'prompt',
};

export default Permissions;
